import { Text, Icon } from '@recargas-dominicanas/core/components';
import { mergeStyle, type Style } from './header.module.css';
import { useSalesStore } from '../../stores/salesStore';
import { formatCurrency } from '@recargas-dominicanas/core/utils';

interface Props {
  logo?: string;
  title: string;
  name: string;
  style?: Style;
  onOpenProfile?: () => void;
}

export function Header(props: Props) {

  const {
    logo,
    title,
    name,
    style: customStyle,
    onOpenProfile
  } = props;

  const style = mergeStyle(customStyle);

  const salesStore = useSalesStore();

  return (
    <div className={style.container}>
      <img className={style.logo} src={logo}/>
      <Text
        text={title}
        className={style.title}/>
      <div className={style.balanceContainer}>
        Balance: <b className={style.balance}>{formatCurrency(salesStore.balance)}</b>
      </div>
      <div 
        className={style.user}
        onClick={onOpenProfile}>
        <Text className={style.name} text={name}/>
        <Icon className={style.icon} icon='expand_more'/>
      </div>
    </div>
  );
}
